import React from 'react';
import empty from '../assets/lottie/empty.json';
import HeaderLottie from './HeaderLottie';

export default (props) =>(
    <div className='item-center'>
        <HeaderLottie source={empty} disableLoop />
        <p className='text-large mgt'>{props.title}</p>
    </div>
)